import { render, staticRenderFns } from "./clientsTable.vue?vue&type=template&id=5946c3f9&scoped=true&"
import script from "./clientsTable.vue?vue&type=script&lang=js&"
export * from "./clientsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946c3f9",
  null
  
)

export default component.exports